export default "__VITE_ASSET__BHUJtsXC__"